// extracted by mini-css-extract-plugin
module.exports =  {"WelcomeScreenNoMessageContainer":"WelcomeScreenNoMessage__WelcomeScreenNoMessageContainer--a45b1"};